import React from 'react';
import Table from './Table';

const History = ({ data = [] }) => {
  return (
    <div style={{ marginLeft: '20px', width: '80%' }}>
      <Table historyView={true} data={data} />
    </div>
  );
};

export default History;
